import Router from 'next/router';
import { useEffect, useRef, useState } from 'react';

export default function TopLoader() {
  const [visible, setVisible] = useState(false);
  const [progress, setProgress] = useState(0);
  const intervalRef = useRef<number | null>(null);

  useEffect(() => {
    const start = (url: string, { shallow }: { shallow: boolean }) => {
      if (shallow) return; // Don't show loader for shallow route changes
      setVisible(true);
      setProgress(12);

      if (intervalRef.current) window.clearInterval(intervalRef.current);
      intervalRef.current = window.setInterval(() => {
        setProgress((p) => {
          // Ease towards 90% while loading
          if (p >= 90) return p;
          const remaining = 90 - p;
          const increment = Math.max(0.8, remaining * 0.06);
          return Math.min(90, p + increment);
        });
      }, 120);
    };

    const done = () => {
      if (intervalRef.current) window.clearInterval(intervalRef.current);
      intervalRef.current = null;

      setProgress(100);

      // Let the bar reach 100%, then fade out
      window.setTimeout(() => {
        setVisible(false);
        setProgress(0);
      }, 250);
    };

    Router.events.on('routeChangeStart', start);
    Router.events.on('routeChangeComplete', done);
    Router.events.on('routeChangeError', done);

    return () => {
      if (intervalRef.current) window.clearInterval(intervalRef.current);
      Router.events.off('routeChangeStart', start);
      Router.events.off('routeChangeComplete', done);
      Router.events.off('routeChangeError', done);
    };
  }, []);

  return (
    <div
      className={[
        'pointer-events-none fixed top-0 left-0 z-[9999] h-0.5 w-full',
        visible ? 'opacity-100' : 'opacity-0',
        'transition-opacity duration-200',
      ].join(' ')}
      aria-hidden="true"
    >
      <div
        className="h-full origin-left bg-black transition-transform duration-150 ease-linear"
        style={{ transform: `scaleX(${progress / 100})` }}
      />
    </div>
  );
}
